import ApiService from './api.service'

const CertificateService = {
	generateCertificate (data){
		return ApiService.post(`/certificate/generate/${data.count}`,data);
	},
	getCertificateByNum (number){
		return ApiService.get(`/certificate/get-by-number/${number}`);
	},
	getCertList (data){
		return  ApiService.post(`/certificate/search-package`,data);
	},
	getEditCertificate(data){
		return ApiService.post(`certificate/search/${data.packageName}`,data);
	}
};

export default CertificateService
